import React from "react";
import DatePicker from "react-datepicker";
import moment from "moment";
import { parseISO } from "date-fns";
import { Typography } from "@mui/material";

// ReactDatePicker component
export default function ReactDatePicker({
  isOpen,
  setIsOpen,
  handleOpen,
  timeDate,
  setTimeDate,
  disabled = false,
  disablePastDates = true,
}) {
  const handleFilterTimes = (time) => {
    const currentDate = new Date();
    const selectedDate = new Date(time);
    return currentDate.getTime() < selectedDate.getTime();
  };

  return (
    <div id="new-react-date-picker">
      <DatePicker
        portalId="root-portal"
        open={isOpen}
        disabled={disabled}
        selected={timeDate ? new Date(timeDate) : ""}
        onChange={(date) => {
          setTimeDate(date ? date : null);
          setIsOpen(false);
        }}
        //   selected={timeDate ? parseISO(timeDate) : null}
        //   onChange={(newDate) => {
        //    setTimeDate(newDate ? newDate.toISOString() : null);
        //    setIsOpen(false);
        //  }}
        filterTime={handleFilterTimes} // Filter time 12Hrs
        minDate={disablePastDates ? new Date() : null}
        showTimeSelect // show time
        timeIntervals={5}
        dateFormat="dd MMM yyyy HH:mm"
        onClickOutside={() => setIsOpen(false)}
        customInput={
          <ReactDatePickerInput
            value={timeDate}
            open={handleOpen}
            disabled={disabled}
          />
        }
        popperPlacement="auto"
      />
    </div>
  );
}

// ReactDatePickerInput
const ReactDatePickerInput = React.forwardRef(
  ({ value, open, disabled }, ref) => {
    return (
      <div
        ref={ref}
        className="react-date-picker"
        onClick={disabled ? undefined : open}
        style={{
          cursor: disabled && "default",
          textDecoration: disabled && "none",
        }}
      >
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: "500",
            color: disabled ? "#9e9e9e" : "#00AB55",
          }}
        >
          {value ? moment(value).format("dddd, D MMMM hh:mm A") : "Date/Time"}
        </Typography>
      </div>
    );
  }
);
